import { useState } from "react";
import { dashboardService } from "@/api/services/dashboardService";
import type { RegisterCustomerVo } from "@/entity/dashboard";
import { DashboardUserFunnel } from "../dashboardLeafWidgets";
import {
    DashboardDateSelect,
    type DashboardDateValue,
    DataWrap,
    toDashboardDateParams,
    useDashboardQuery,
    WidgetBody
} from "../dashboardWidgets";

/** 注册用户统计，按旧 Vue 页面组合日期筛选和认证转化漏斗。 */
export default function RegisteredCustomerStatistic() {
    const [time, setTime] = useState<DashboardDateValue>(1);
    const { data, loading, error } = useDashboardQuery<RegisterCustomerVo>(
        () => dashboardService.getRegisteredCustomerStatistic(toDashboardDateParams(time)),
        [time]
    );

    return (
        <DataWrap
            title="注册用户统计"
            className="registered-customer-statistic"
            option={
                <DashboardDateSelect
                    value={time}
                    onChange={setTime}
                    options={["all", "month", "quarter", "year"]}
                    defaultActive="all"
                />
            }
        >
            <WidgetBody loading={loading} error={error}>
                <DashboardUserFunnel data={data} />
            </WidgetBody>
        </DataWrap>
    );
}
